import { CSSProperties } from "react";
import { Stack, Spinner } from "react-bootstrap";

const Loading = ({expandHeight=false}) => {
    var style: CSSProperties = {padding:10, display: 'flex', justifyContent: 'center', height:"90vh"};
    if (!expandHeight)
        style = {zIndex: 100, padding:10, display: 'flex', position: "absolute", right: "50%"};
    return (
        <Stack style={style} 
            direction="horizontal" gap={2}>
            <Spinner  animation="grow" size="sm"/>
            <Spinner animation="grow" size="sm"/>
            <Spinner animation="grow" size="sm"/>
        </Stack>
    )
}

export default Loading;